const URL_RE = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;

export function renderTextWithLinks(text) {
  const raw = String(text ?? "");
  if (!raw) return null;
  const parts = raw.split(URL_RE);
  return parts.map((part, i) => {
    if (!part) return null;
    if (/^(https?:\/\/|www\.)/i.test(part)) {
      const href = part.startsWith("http") ? part : `https://${part}`;
      return (
        <a key={i} href={href} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    return <span key={i}>{part}</span>;
  });
}
